export default __webpack_public_path__ + "img/213f4c289cc256764abf50e36947a478.svg";